module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gn-7bf7a35a82ae814ed25d6219f39db9d3.svg";